<template>
  <div align="center">
    <v-data-table
      :headers="headers"
      :items="desserts"
      item-key="ID_Registro"
      class="elevation-1"
    >
      <!-- Documento Actual -->
      <template v-slot:item.Actual="{ item }">
        <v-tooltip location="bottom" color="white">
          <template v-slot:activator="{ props }">
            <v-icon
              @click="DocumentoActual(item.raw)"
              color="teal-accent-4"
              v-bind="props"
              >mdi-comment-eye-outline</v-icon
            >
          </template>
          <span>Documento Actual</span>
        </v-tooltip>
      </template>
      <!-- Histórico -->
      <template v-slot:item.Historico="{ item }">
        <v-tooltip location="bottom" color="white">
          <template v-slot:activator="{ props }">
            <v-icon
              @click="historicoconsultadocumentos(item.raw)"
              color="blue-darken-3"
              v-bind="props"
              >mdi-archive-eye-outline</v-icon
            >
          </template>
          <span>Histórico</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <!-- Linea Progreso -->
    <div class="d-flex align-center flex-column">
      <!-- Linea de progreso -->
      <v-dialog v-model="progreso" persistent width="auto">
        <v-card color="red-darken-4">
          <v-card-text>
            Espera un momento...
            <v-toolbar align="center" color="red-darken-4">
              <v-img
                class="mx-auto"
                :width="5"
                src="/static/iconos/logo2.png"
              ></v-img>
            </v-toolbar>
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <!-- Visores -->
    <v-dialog v-model="modal" persistent max-width="1200px">
      <v-toolbar dark color="red-darken-4">
        <v-toolbar-title
          ><v-icon left>mdi-eye-settings-outline</v-icon> Visualizar archivo
          {{ infollaves.Contrato != null ? infollaves.Contrato : "" }} -
          {{ infollaves.Ref_1 != null ? infollaves.Ref_1 : "" }} -
          {{ infollaves.Document_ID != null ? infollaves.Document_ID : "" }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn class="d-none d-md-block" dark text @click="modal = false"
            >Cerrar</v-btn
          >
        </v-toolbar-items>
      </v-toolbar>
      <card-visores
        v-if="LinkDocumento != null"
        :LinkDocumento="LinkDocumento"
        :NombreDocumento="NombreDocumento"
        :Formato="Formato"
        :infollaves="infollaves"
        :TipoDocumemto="TipoDocumemto"
      ></card-visores>
    </v-dialog>
    <!-- Histórico de documentos -->
    <v-dialog v-model="modal1" persistent max-width="1200px">
      <v-toolbar dark color="red-darken-4">
        <v-toolbar-title
          ><v-icon left>mdi-archive-eye-outline</v-icon>
          Histórico de archivos
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn class="d-none d-md-block" dark text @click="modal1 = false"
            >Cerrar</v-btn
          >
        </v-toolbar-items>
      </v-toolbar>
      <card-historicodoc
        v-if="itemconsultadocumento != null"
        :ConsulaDocumento="itemconsultadocumento"
      ></card-historicodoc>
    </v-dialog>
  </div>
</template>
<script>
import store from "@/store";
import visores from "@/views/TCI/Documentos/DocumentosComponents/Visores/Visores.vue";
import historicodocumentos from "@/views/TCI/Documentos/ConsultaDocumentos/HistoricoDocumento.vue";
export default {
  name: "documentos-modal",
  components: {
    "card-visores": visores,
    "card-historicodoc": historicodocumentos,
  },
  props: {
    infollaves: {
      type: Object,
      default: null,
      Description: "Información de llaves",
    },
    infoCampo: {
      type: Object,
      default: null,
      Description: "Información del campo tipo Datepicker para ser añadido",
    },
  },
  data() {
    return {
      item: this.infoCampo,
      itemdocumento: [],
      itemconsultadocumento: [],
      dessertsresult: [],
      progreso: false,
      modal: false,
      modal1: false,
      archivo: null,
      LinkDocumento: null,
      RutaFisica: null,
      NombreDocumento: null,
      TipoDocumemto: null,
      Formato: null,
      headers: [
        { title: "Descripción", key: "DescDocumento_ID", sortable: false },
        {
          title: "Actual",
          key: "Actual",
          sortable: false,
          align: "center",
        },
        {
          title: "Histórico",
          key: "Historico",
          sortable: false,
          align: "center",
        },
      ],
      desserts: [],
      arraydocumentos: [],
    };
  },
  methods: {
    // Guardado de datos
    async consultardoc() {
      this.progreso = true;
      let formData = new FormData();
      // Información Data
      var data = {
        TypeDocument_ID:
          this.infollaves.TypeDocument_ID == null
            ? ""
            : this.infollaves.TypeDocument_ID,
        Document_ID:
          this.infollaves.Document_ID == null
            ? ""
            : this.infollaves.Document_ID,
        Contrato:
          this.infollaves.Contrato == null ? "" : this.infollaves.Contrato,
        Ref_1: this.infollaves.Ref_1 == null ? "" : this.infollaves.Ref_1,
        IDServicio:
          this.infollaves.IDServicio == null ? "" : this.infollaves.IDServicio,
        Soporte_ID:
          this.infollaves.Secuencia_ID == null
            ? 0
            : this.infollaves.Secuencia_ID,
        Solicitud:
          this.infollaves.Solicitud == null ? "" : this.infollaves.Solicitud,
        IDPoliza:
          this.infollaves.IDPoliza == null ? "" : this.infollaves.IDPoliza,
        UsuarioLogin: null,
        PerfilLogin: null,
        ID_Comunicacion: null,
        Vista: "1",
      };

      console.log(this.arraydocumentos);
      // Agregar el array de Documentos como JSON en un campo de texto
      formData.append("InfoDocumentos", JSON.stringify(this.arraydocumentos));

      // Agregar el array de objetos como JSON en un campo de texto
      formData.append("metadata", JSON.stringify(data));
      this.axios
        .post("/archivosdocumentos/CT0", formData)
        .then((response) => {
          this.desserts = response.data;
        })
        .catch((error) => {
          this.dessertsresult = [];
          this.desserts = [];
          this.arraydocumentos = [];
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: " [404] No existen datos para esta consulta.",
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " [500] El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
        });
    },

    //Limpieza de campos
    clear() {
      this.dessertsresult = [];
      this.desserts = [];
      this.arraydocumentos = [];
      var Documento = this.$store.getters.MDocumentos;
      if (this.item == null) {
        if (
          this.infollaves.IDServicio != null &&
          this.infollaves.IDServicio > 0
        ) {
          this.desserts = Documento.filter(
            (item) =>
              item.ServicioID1 == this.infollaves.IDServicio ||
              item.ServicioID2 == this.infollaves.IDServicio ||
              item.ServicioID3 == this.infollaves.IDServicio ||
              item.ServicioID4 == this.infollaves.IDServicio ||
              item.ServicioID5 == this.infollaves.IDServicio
          );
        } else if (
          this.infollaves.IDPoliza != null &&
          this.infollaves.IDPoliza > 0
        ) {
          this.desserts = Documento.filter((item) => item.VisibleCaso == "S");
        }
      } else {
        this.desserts = this.item.Documento;
      }

      for (var i = 0; i < this.desserts.length; i++) {
        if (this.item == null) {
          this.desserts[i].index = i;
        }
        this.desserts[i].Combinado = false;
        this.desserts[i].MuestraArchivo = false;
        this.desserts[i].IconoArchivo = "";
        this.desserts[i].DescArchivo = "";
        var inforesult = {
          Documentos_ID: this.desserts[i].DocumentoID,
        };
        this.arraydocumentos.push(inforesult);
      }
      this.consultardoc();
    },

    // Documento Versión Actual
    DocumentoActual(registro) {
      this.TipoDocumemto = registro.DescDocumento_ID;
      this.RutaFisica = null;
      this.LinkDocumento = null;
      this.NombreDocumento = null;
      this.Formato = null;
      var documentoconsulta = this.desserts.filter(
        (item) => item.Documento_ID == registro.Documento_ID
      );
      if (documentoconsulta != undefined && documentoconsulta.length > 0) {
        documentoconsulta = documentoconsulta[0];
        this.RutaFisica = documentoconsulta.DocumentosExistentes[0].RutaFisica;
        this.LinkDocumento = documentoconsulta.DocumentosExistentes[0].RutaLink;
        this.NombreDocumento = documentoconsulta.DocumentosExistentes[0].Nombre;
        this.Formato = documentoconsulta.DocumentosExistentes[0].Formato;
        this.progreso = true;
        // Consult Archivo
        this.axios
          .get(
            "/archivosdocumentos/ArchivoEspecifico?rutaComplementaria=" +
              this.RutaFisica +
              "&nombreArchivo=" +
              this.NombreDocumento
          )
          .then((response) => {
            this.LinkDocumento = response.data;
            this.modal = true;
          })
          .catch((e) => console.log(e))
          .finally(() => {
            this.progreso = false;
          });
      }
    },
    // Chane Histórico de documentos
    historicoconsultadocumentos(registro) { 
      var documentoconsulta = this.desserts.filter(
        (item) => item.Documento_ID == registro.Documento_ID
      );
      this.itemconsultadocumento = null;
      if (documentoconsulta != undefined && documentoconsulta.length > 0) {
        documentoconsulta = documentoconsulta[0];
        this.itemconsultadocumento = documentoconsulta.DocumentosExistentes;
        this.modal1 = true;
      }
    },
  },
  mounted() {
    this.clear();
  },
};
</script>
